/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueLoading from 'vue-loading-template';
import { Tabs, Tab } from 'vue-tabs-component';
Vue.use(BootstrapVue);
Vue.use(VueLoading);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('condition', require('./components/Condition.vue').default);
Vue.component('segmented-control', require('./components/SegmentedControl').default);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    mounted() {
        $('body').bootstrapMaterialDesign();
    },
});

import Axios from 'axios';
Axios.interceptors.request.use((config) => {
    if(['post', 'put', 'patch', 'delete'].includes(config.method)) {
        config.headers['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
